import { VisitorChild1 } from "./visitorChild1";

 export class Visitor1 {
    id: number;
    fullName: string;
    email: string;
    phone: string;
    address: string;
    city: string;
    roomId: number;
    birthDate: Date;
    dateBirthFromQuery:Date;
    dateBirthToQuery:Date
    numberOfVisit: number;
    visitorStatus: number;
    comment: string;
    children: VisitorChild1[];
    gratis:boolean
    parentId: number
    signatureUrl?: string | null;
    constructor() {
      this.fullName = '';
      this.email = '';
      this.phone = '';
      this.address = '';
      this.city ='';
      this.birthDate = null;
      this.dateBirthFromQuery=null;
      this.dateBirthToQuery=null
      this.visitorStatus = null;
      this.comment = '';
      this.gratis=false;
      this.parentId=null;
    }
  }
